module.exports = __webpack_public_path__ + "static/media/siva.12d8ec66.png";